import { useTheme } from '@rneui/themed'
import { showShareHeaderButton } from 'chat/shared/header_share_button'
import { PDFScreenProps } from 'home/stack/types'
import { useCallback, useLayoutEffect, useState } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { PDF_MIME_TYPE } from 'shared/document_picker'
import { showHeaderTitle } from 'shared/header/header_title'
import { shareAttachment } from 'shared/utils'
import { PdfViewer } from './view'

export function PDFScreen({ navigation, route }: PDFScreenProps) {
  const [error, setError] = useState<Error | undefined>()
  const title = route.params.name ?? 'PDF File'
  const { theme } = useTheme()
  const [isShareLoading, setShareLoading] = useState(false)

  useLayoutEffect(() => {
    showHeaderTitle(navigation, title)
  }, [navigation, title])

  const onShareAttachment = useCallback(async () => {
    setShareLoading(true)
    await shareAttachment({
      uri: route.params.url,
      mimeType: PDF_MIME_TYPE,
      name: route.params.name,
    })
    setShareLoading(false)
  }, [route.params.name, route.params.url])

  useLayoutEffect(() => {
    showShareHeaderButton({
      navigation,
      theme,
      onPress: onShareAttachment,
      loading: isShareLoading,
    })
  }, [
    isShareLoading,
    navigation,
    onShareAttachment,
    route.params.name,
    route.params.url,
    theme,
  ])

  return (
    <StatusBoundary isLoading={!route.params.url} error={error}>
      <PdfViewer
        source={{ uri: route.params.url }}
        onError={setError}
        goBack={() => navigation.goBack()}
        title={title}
      />
    </StatusBoundary>
  )
}
